import { SxProps } from '@mui/material';
import theme from '../config/theme';

export const BRAND_NAME = 'Mélusine Cantine - Traiteur';

// Login button id for Fruggr
export const LOGIN_BUTTON_ID = 'app-login';

// Header
export const HEADER_DROPDOWN_MENU_ID = 'header-dropdown-menu';
export const PROFILE_MENU_ID = 'profile-menu';
export const MAIN_MENU_ID = 'main-content';
export const HEADER_HEIGHT = '7rem';
export const HEADER_LINK_STYLE: (props: { isActive: boolean }) => SxProps = ({ isActive = false }) => {
  return {
    justifyContent: 'flex-start',
    p: 0,
    fontFamily: theme.typography.h3.fontFamily,
    fontWeight: 600,
    textAlign: 'left',
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    textDecoration: isActive ? 'underline' : 'none',
    fontSize: isActive ? '1.5rem' : '1.375rem',
    textUnderlineOffset: '4px',
    '&:hover, &:focus, &:focus-visible, &:active': {
      '--variant-textBg': 'transparent',
      backgroundColor: 'transparent !important',
      boxShadow: 'none',
      textDecoration: 'underline',
      transition: 'none',
      fontSize: '1.5rem'
    },
    '&:focus-visible': {
      fontSize: '1.5rem'
    }
  };
};

export const HEADER_LI_STYLE: (props: { isActive: boolean }) => SxProps = ({ isActive = false }) => {
  return {
    alignItems: 'stretch',
    display: 'flex',
    backgroundColor: 'transparent',
    borderRadius: '0px',
    color: isActive ? theme.palette.text.primary : theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'transparent',
      borderRadius: '8px'
    },
    '&:has(:focus-visible)': {
      backgroundColor: theme.palette.primary.light,
      borderRadius: '8px',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: theme.palette.primary.main
    },
    '&:active': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.palette.primary.main,
      borderRadius: '8px',
      transition: 'background-color 0.2s ease'
    }
  };
};

// Footer
export const FOOTER_HEIGHT = '13.75rem';
